module.exports = __webpack_public_path__ + "img/lancamento_temporario.4fac9904.webp";